import { Navigate, Outlet, useLocation } from "react-router-dom";
import { PageLoader } from "@/layouts/components/PageLoader/PageLoader";
import { routes } from "../routes";
import { useOnboarding } from "@/features/onboarding/hooks/useOnboarding";
import type { UserOnboardingState } from "@/features/onboarding/types/onboarding";

export const QuestionnaireGuard = () => {
  const location = useLocation();
  const { onboardingState, isOnboardingStateLoading } = useOnboarding(true);

  if (isOnboardingStateLoading) {
    return <PageLoader />;
  }

  const nextStep = getNextQuestionnaireStep(onboardingState!);

  if (location.pathname !== nextStep) {
    return <Navigate to={nextStep} replace />;
  }

  return <Outlet />;
};

function getNextQuestionnaireStep(onboarding: UserOnboardingState) {

  if (!onboarding.financialNeed) return routes.questionnaire.financialNeed;
  if (!onboarding.desiredAmount) return routes.questionnaire.desiredAmount;

  return routes.wizard.base;
}
